const namespace = '[Job Queue]';

export const JOB_QUEUE_UPDATE_ACTIVE = `${namespace} JOB QUEUE UPDATE`;
export const JOB_QUEUE_SHOULD_WATCH = `${namespace} JOB QUEUE SHOULD WATCH`;
export const JOB_QUEUE_ADD = `${namespace} JOB QUEUE ADD`;
export const JOB_QUEUE_RESET_JOBS_PROCESSED = `${namespace} JOB QUEUE RESET JOBS PROCESSED`;
